import { section } from "./global-interfaces";

export const SECTION = "section";
export const CATEGORY = "category";
export const CARD = "card";
export const FOCUS = "focus"

// chart types
export enum CHART_TYPES {
  SUBSET = "subset",
  VERT = "vertical",
  GROUP_VERT = "grouped_vertical",
  HORIZ = "horizontal",
  INLINE_HORIZ = "inline_horizontal",
  PIE = "pie",
  PIE_LEGEND = "pie_legend",
  TEXT = "text",
  NESTED_TEXT = "text_nested",
  LIST = "list",
  WORD = "word",
  HEADLINE = "headline",
  ANNOTATION = "annotation",
}


export enum Colors {
  ORANGE = "orange",
  YELLOW = "yellow",
  GREEN = "green",
  TEAL = "teal",
  BLUE = "blue",
  PERIWINKLE = "periwinkle",
  RED = "red",
  PINK = "pink",
  PURPLE = "purple",
  // BLACK = "black"
}

export enum ColorLevel {
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
}

export enum Sections {
  INTRODUCTION = "Introduction",
  SUICIDE_MENTAL = "Suicide & Mental Health",
  SUPPORT = "Finding Support",
  COVID = "Covid-19",
  TGNB = "Supporting Transgender & Nonbinary Youth",
  FOOD_INSEC = "Food Insecurity",
  CONVERSION = "Conversion Therapy",
  DISCRIMINATION = "Discrimination",
  AFFIRMING = "Affirming Spaces",
  FINDING_JOY = "Finding Joy",
  RESEARCH_METHODG = "Research & Methodology",
}

// social
export const LINK = "link";
export const TWITTER = "twitter";
export const FB = "facebook";

//misc.
export const EMPHASIS_CHAR = "^";
export const ITALICS_CHAR = "_";
export const TITLE = "title";
export const SUBTITLE = "subtitle";
export const HIGHLIGHT = "highlight";

/* client requested this order and opacity pie chart and vertical bar charts, which translates to question ID "5_1_1_1_0" and question ID "5_2_1_1_0" */
export const CUST_PERSONS_ORDER = [ "None", "A few", "Some", "A lot", "All or most" ]
export const CUST_AGE_ORDER = [ "13-17 year olds", "18-24 year olds" ]

// color mappings
const formatHash = (str: string) => str.replace(/\W+/g, "").replace(/(\s+)/g, "-"); // replaces '&' and ' ' with '-'
export const SECTION_MAPPING: section[] = [
  {
    title: Sections.INTRODUCTION,
    color: Colors.ORANGE,
    hash: formatHash(Sections.INTRODUCTION),
    path: "/assets/info-outline.svg",
    pathActive: "/assets/info-fill.svg",
  },
  {
    title: Sections.SUICIDE_MENTAL,
    color: Colors.YELLOW,
    hash: formatHash(Sections.SUICIDE_MENTAL),
    path: "/assets/t-icons-suicide-outline.svg",
    pathActive: "/assets/t-icons-suicide-fill.svg",
  },
  {
    title: Sections.SUPPORT,
    color: Colors.TEAL,
    hash: formatHash(Sections.SUPPORT),
    path: "/assets/research-outline.svg",
    pathActive: "/assets/research-fill.svg",
  },
  {
    title: Sections.COVID,
    color: Colors.GREEN,
    hash: formatHash(Sections.COVID),
    path: "/assets/mask-outline.svg",
    pathActive: "/assets/mask-fill.svg",
  },
  {
    title: Sections.TGNB,
    color: Colors.BLUE,
    hash: formatHash(Sections.TGNB),
    path: "/assets/transgender-outline-2.svg",
    pathActive: "/assets/transgender-fill.svg",
  },
  {
    title: Sections.FOOD_INSEC,
    color: Colors.PERIWINKLE,
    hash: formatHash(Sections.FOOD_INSEC),
    path: "/assets/food-outline.svg",
    pathActive: "/assets/food-fill.svg",
  },
  {
    title: Sections.CONVERSION,
    color: Colors.PURPLE,
    hash: formatHash(Sections.CONVERSION),
    path: "/assets/change1-outline.svg",
    pathActive: "/assets/change1-fill.svg",
  },
  {
    title: Sections.DISCRIMINATION,
    color: Colors.PINK,
    hash: formatHash(Sections.DISCRIMINATION),
    path: "/assets/trevor-danger-outline.svg",
    pathActive: "/assets/trevor-danger-fill.svg",
  },
  {
    title: Sections.AFFIRMING,
    color: Colors.RED,
    hash: formatHash(Sections.AFFIRMING),
    path: "/assets/housing-outline.svg",
    pathActive: "/assets/housing-fill.svg",
  },
  {
    title: Sections.FINDING_JOY,
    color: Colors.YELLOW,
    hash: formatHash(Sections.FINDING_JOY),
    path: "/assets/heart-outline.svg",
    pathActive: "/assets/heart-fill.svg",
  },
  {
    title: Sections.RESEARCH_METHODG,
    color: Colors.ORANGE,
    hash: formatHash(Sections.RESEARCH_METHODG),
    path: "/assets/methodology-outline.svg",
    pathActive: "/assets/methodology-fill.svg",
  }
].map((d, i) => ({ ...d, index: i }));